import React, { useState } from 'react'
import { Card } from 'antd'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { filtersSelector } from '../../../redux/context/filters/selectors'
import { Loan } from '../types/Loan'
import RepaymentScheduleModal from './LoanRepaymentSceduleModal'
import LoanSummaryStats from './LoanSummary'
import LoanGrid from './LoanGrid'
import LoanInterestModal from './LoanInterestModal'
import { LoanSummaryBalanceSheetRow } from '../types/LoanSummary'
import { Investment } from '../../../types/investment/Investment'

type LoanGroupProps = {
  balanceSheetRowId: number
  loansByBalansheetRow: LoanSummaryBalanceSheetRow
  isExisting: boolean
  toggleModal: (investment?: Investment) => void
}

const LoanGroup: React.FC<LoanGroupProps> = ({ balanceSheetRowId, loansByBalansheetRow, isExisting, toggleModal }) => {
  const { t } = useTranslation()
  const { budgetingScenario } = useSelector(filtersSelector)
  const isLocked = budgetingScenario?.isLocked === true
  const [loanForRepaymentScheduleModal, setLoanForRepaymentScheduleModal] = useState<Loan | null>(null)
  const [loanInterestRatesModal, setLoanInterestRatesModal] = useState<Loan | null>(null)

  const repaymentHandleOk = () => {
    setLoanForRepaymentScheduleModal(null)
  }

  const toggleRepaymentSchedule = (e: React.MouseEvent<HTMLElement, MouseEvent>, loan: Loan) => {
    e.stopPropagation()
    setLoanForRepaymentScheduleModal(loan)
  }

  const toggleInterestRate = (e: React.MouseEvent<HTMLElement, MouseEvent>, loan: Loan) => {
    e.stopPropagation()
    setLoanInterestRatesModal(loan)
  }

  const interestRatesHandleOk = () => {
    setLoanInterestRatesModal(null)
  }

  return (
    <Card>
      <RepaymentScheduleModal handleOk={repaymentHandleOk} loan={loanForRepaymentScheduleModal} isLocked={isLocked} />
      {loanInterestRatesModal ? (
        <LoanInterestModal handleOk={interestRatesHandleOk} loan={loanInterestRatesModal} isLocked={isLocked} />
      ) : null}
      <Card.Meta
        title={<span style={{ fontSize: 16 }}>{t(`balanceSheet:${balanceSheetRowId}`)}</span>}
        description={
          isExisting ? (
            <LoanSummaryStats
              isExisting={isExisting}
              summary={loansByBalansheetRow.summary}
              balanceSheetRowId={loansByBalansheetRow.balanceSheetRowId}
            />
          ) : undefined
        }
      />
      <div style={{ marginTop: 16 }} />
      <LoanGrid
        isExisting={isExisting}
        balanceSheetRowId={balanceSheetRowId}
        loans={loansByBalansheetRow.loans}
        toggleRepaymentSchedule={toggleRepaymentSchedule}
        toggleInterestRate={toggleInterestRate}
        toggleModal={toggleModal}
      />
    </Card>
  )
}

export default LoanGroup
